var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxesArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25H15L12 14.25L9 11.25H11.25V0.75H12.75V11.25ZM5.25 8.25H2.25C1.4175 8.25 0.75 8.9175 0.75 9.75V12.75C0.75 13.5825 1.4175 14.25 2.25 14.25H5.25C6.0825 14.25 6.75 13.5825 6.75 12.75V9.75C6.75 8.9175 6.0825 8.25 5.25 8.25ZM3.2025 13.125L1.305 11.2125L2.1075 10.425L3.21 11.5425L5.4 9.375L6.195 10.1625L3.2025 13.125ZM5.25 0.75H2.25C1.4175 0.75 0.75 1.4175 0.75 2.25V5.25C0.75 6.0825 1.4175 6.75 2.25 6.75H5.25C6.0825 6.75 6.75 6.0825 6.75 5.25V2.25C6.75 1.4175 6.0825 0.75 5.25 0.75ZM5.25 5.25H2.25V2.25H5.25V5.25Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxesArrowDown);
export default __webpack_public_path__ + "static/media/CheckboxesArrowDown.ccb6e6820fc150a229d0f4f7e58dd36b.svg";
export { ForwardRef as ReactComponent };